export default "__VITE_ASSET__BZwPCEOh__"